import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useMediaQuery, Tabs, Tab, Box, Typography, Divider, Link, Button } from '@mui/material';
import { useTheme } from '@material-ui/core';

import { AuthModal } from 'src/App/Dashboards/Market/Modals';
import { getTokenThunk } from 'src/store/Auth/actions';
import { getUserInfo } from 'src/store/Dashboard/actions';
import { initializeApiData } from 'src/store/Api';
import { ApiOverviewPage, ApiUsagePage, ApiCreditsPage } from './Pages';
import logoMobile from 'src/App/assets/logoMobile.jpg';

const ApiDashboard = ({}) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down(900));
  const urlParams = new URLSearchParams(window.location.search);
  const sessionId = urlParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      setActiveTab(2);
    }
  }, []);

  const isLoggedIn = Boolean(dispatch(getTokenThunk()));
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    if (!isLoggedIn) {
      setAuthModalOpen(true);
    } else {
      dispatch(getUserInfo());
      // Initialize API data when user is logged in
      dispatch(initializeApiData());
    }
  }, [isLoggedIn, dispatch]);

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <ApiOverviewPage setActiveTab={setActiveTab} />;
      case 1:
        return <ApiUsagePage />;
      case 2:
        return <ApiCreditsPage />;
      default:
        return <ApiOverviewPage setActiveTab={setActiveTab} />;
    }
  };

  return (
    <>
      {isLoggedIn && (
        <Box sx={{ width: '100%', px: matches ? 2 : 20, py: 2 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexDirection: matches ? 'column' : 'row',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Button onClick={() => (window.location.href = '/')}>
                <img
                  src={logoMobile}
                  style={{
                    width: '7rem',
                    objectFit: 'contain',
                    height: 38,
                    [theme.breakpoints.down(370)]: {
                      width: '7rem',
                      height: 30,
                    },
                  }}
                />
              </Button>
            </Box>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              aria-label="API dashboard tabs"
              sx={{
                padding: '0 !important',
                border: 'none',
                marginBottom: '0 !important',
              }}
            >
              <Tab label="Overview" sx={{ fontSize: '16px' }} />
              <Tab label="Usage" sx={{ fontSize: '16px' }} />
              <Tab label="Credits" sx={{ fontSize: '16px' }} />
            </Tabs>
          </Box>
          <Divider sx={{ mb: 2 }} />
          {renderTabContent()}

          {/* footer */}
          <Divider sx={{ my: 2 }} />
          <Box sx={{ pb: 4 }}>
            <Typography variant="body2" textAlign="center">
              Contact <Link href="mailto:jae@airbtics.com">jae@airbtics.com</Link> for any
              questions.
            </Typography>
          </Box>
        </Box>
      )}

      {!isLoggedIn && (
        <AuthModal
          authModalOpen={authModalOpen}
          setAuthModalOpen={setAuthModalOpen}
          getUserInfo={() => dispatch(getUserInfo())}
          getTokenThunk={() => dispatch(getTokenThunk())}
          matches={matches}
          landing="overview"
          setShowOnboardingModal={() => {}}
        />
      )}
    </>
  );
};

export default ApiDashboard;
